export class FileSizeConverter {
    private unit:string;
    private unitCounter = -1;
    private size:number;
    constructor(sizeInByte:number) {this.size = sizeInByte;}
    convertBytes() {
        do {
                this.size = this.size/1024;
                this.unitCounter++;
        }while(this.size >= 1024);

        switch(this.unitCounter) {
            case 0: this.unit='kb'; this.unitCounter=-1;break;

            case 1: this.unit='mb';this.unitCounter=-1;break;

            case 2: this.unit='gb';this.unitCounter=-1;break;


        }
    }

    getSize() {
        return Number.parseFloat(this.size.toFixed(2));
    }

    getUnit() {
        return this.unit;
    }
}
